import React from 'react';
import T from 'i18n-react';

import MetaTags from 'Components/MetaTags/MetaTags';
import { DiscoverMWMovePage } from 'Components/StaticPages/DiscoverMWMove';
import texts from 'Components/texts.json';

import metaImage from '../public/static/images/og-discover-motorway-move.jpg';

T.setTexts(texts);

const MotorwayMove = (): React.ReactElement => (
	<>
		<MetaTags
			// @ts-ignore needs to rewrite MetaTags to TS, and stop using withRouter for it to work
			imagePrependHost
			noIndex
			description={T.translate('metaTags.pages.discoverMotorwayMove.description')}
			height={metaImage.height}
			image={metaImage.src}
			title={T.translate('metaTags.pages.discoverMotorwayMove.title')}
			width={metaImage.width}
		/>
		<DiscoverMWMovePage />
	</>
);

export default MotorwayMove;
